import React, { useEffect, useState } from 'react';

import { getEdlySiteConfig, updateEdlySiteConfig } from 'services/siteConfiguration';
import { messageNotification } from 'helpers';

const TaskCompletionNotifications = () => {
  const [checked, setCheckedBox] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getEdlySiteConfig()
      .then((res) => {
        setCheckedBox(!res.data.cms.DISABLE_CMS_TASK_EMAILS);
      })
      .catch((error) => {
        messageNotification('danger', 'Error', `${error}`);
      });
  }, []);

  const handleClick = async () => {
    const updateCheck = !checked;
    setIsLoading(true);
    setCheckedBox(updateCheck);
    const data = { cms: { DISABLE_CMS_TASK_EMAILS: !updateCheck } };
    updateEdlySiteConfig(data)
      .then(() =>
        messageNotification(
          'success',
          'Key updated',
          `Task completion notifications have been ${updateCheck ? 'enabled' : 'disabled'}`
        )
      )
      .catch((error) => {
        messageNotification('danger', 'Error', `${error}`);
        setCheckedBox(!updateCheck);
      })
      .finally(() => setIsLoading(false));
  };

  return (
    <div className="integration-holder mb-4">
      <div className="subheader-holder">
        <h5>Task completion notifications</h5>
        <div className="checkbox_Container d-flex align-items-center">
          <p className="m-0 flex-grow-1">
            Receive email notifications when tasks are completed in Studio, including course imports and exports, link
            updates, and content migrations.
          </p>
          <input type="checkbox" checked={checked} className="checkbox flex-shrink-0" onChange={handleClick} />
          {isLoading && (
            <small className="text-muted ms-2 d-flex align-items-center">
              <span
                className="spinner-border me-1"
                role="status"
                style={{ width: '0.75rem', height: '0.75rem' }}
              ></span>
              Saving...
            </small>
          )}
        </div>
      </div>
    </div>
  );
};

export default TaskCompletionNotifications;
